<template name="default">
    <article class="large-4 medium-6 small-12 cell">
        <a
            :href="options.Link.Url"
            :target="options.Link.Target"
        >
            <h3
                v-html="options.Title"
            />
            <p
                v-if="showAbstract"
                class="text-color-white"
                v-html="options.Abstract"
            />
        </a>
    </article>
</template>
<script>

export default {
    name: 'BoxComponent',
    props: {
        options: {
            type: Object,
            default() {
                return {
                    IsExperienceEditor: false,
                    Url: ''
                };
            }
        },
        showAbstract: {
            type: Boolean,
            default() {
                return false;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
</style>
